module.exports = __webpack_public_path__ + "static/img/6.d454dd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/6.png
// module id = 8Pyo
// module chunks = 0